<script lang="ts">
	export let formaction: string | null = null;
	export let secondary: boolean = false;
	export let disabled: boolean = false;
	export let href: string | null = null;
	export let title: string;
	export let light: boolean = false;
	
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	function action() {
		dispatch('clck');
	}

	let isClicked = false;
	let style = 'hover:opacity-90 inline-block text-center w-full rounded-xl px-4 py-3 ';

	if (secondary) {
		if (light) {
			if (disabled) {
				style += 'bg-secondary-100 text-secondary-500/50';
			} else {
				style += 'bg-secondary-100 text-secondary-500';
			}
		} else {
			if (disabled) {
				style += 'bg-secondary-100 text-secondary-500/50 ';
			} else {
				style += ' bg-secondary-500 text-secondary-100';
			}
		}
	} else {
		if (light) {
			if (disabled) {
				style += 'bg-primary-100 text-primary-500/50';
			} else {
				style += 'bg-primary-300 text-primary-500';
			}
		} else {
			if (disabled) {
				style += 'bg-primary-100 text-primary-500/50 ';
			} else {
				style += ' bg-primary-500 text-primary-50';
			}
		}
	}
</script>

{#if href}
	<a {href} class=" {style} "
		><div class="flex gap-1 items-center justify-center">
			{#if $$slots.icon}
				<div class="w-4">
					<slot name="icon"></slot>
				</div>
			{/if}
			{title}
		</div></a
	>
{:else if formaction}
	<button {disabled} on:click={action} {formaction} class=" {style}">
		<div class="flex gap-1 items-center justify-center">
			{#if $$slots.icon}
				<div class="w-4">
					<slot name="icon"></slot>
				</div>
			{/if}
			{title}
		</div>
	</button>
{:else if disabled}
	<button disabled class="{style} "
		><div class="flex gap-1 items-center justify-center">
			{#if $$slots.icon}
				<div class="w-4">
					<slot name="icon"></slot>
				</div>
			{/if}
			{title}
		</div></button
	>
{:else}
	<button class=" {style} " on:click={action}
		><div class="flex gap-1 items-center justify-center">
			{#if $$slots.icon}
				<div class="w-4">
					<slot name="icon"></slot>
				</div>
			{/if}
			{title}
		</div></button
	>
{/if}
